import { render, staticRenderFns } from "./ItemHD.vue?vue&type=template&id=88397a20&scoped=true"
import script from "./ItemHD.vue?vue&type=script&lang=js"
export * from "./ItemHD.vue?vue&type=script&lang=js"
import style0 from "./ItemHD.vue?vue&type=style&index=0&id=88397a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88397a20",
  null
  
)

export default component.exports